import { Box, Card, Grid, styled, Typography } from '@mui/joy';

import { Button } from 'core/components';

export const PageGrid = styled(Grid)({
  height: '100%',
  width: '100%',
  position: 'absolute',
  left: '0',
  bottom: '0',
  justifyContent: 'center',
});

export const LeftSide = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const LeftSideContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '20px',
  width: '80%',

  ['@media (max-width: 899px)']: {
    paddingTop: 20,
    position: 'absolute',
    top: '40%',
    height: '60%',
    justifyContent: 'flex-start',
  },
});

export const LogoImage = styled('img')({
  position: 'absolute',
  top: 0,
  left: 8,

  ['@media (max-width: 899px)']: {
    top: 'calc(100% - 92px)',
    left: 'calc(50% - 110px)',
    bottom: 0,
  },
});

export const RightSide = styled(Grid)({
  height: '100%',

  ['@media (max-width: 899px)']: {
    position: 'absolute',
    zIndex: -1,
    bottom: '60%',
    height: '40%',
    width: '100%',
  },
});

export const TitleSignIn = styled(Typography)({
  fontSize: 32,
});

export const SsoButton = styled(Button)({
  fontSize: 20,
  fontWeight: 400,
});

export const Logo = styled(Card)(({ theme }) => ({
  height: '100%',
  justifyContent: 'center',
  backgroundColor: theme.palette.custom.background.dark,
  border: 0,
  borderRadius: 0,
}));

export const Image = styled('img')({
  maxHeight: '100%',
  maxWidth: 400,
  margin: 'auto',
});
